import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM19.93 11H12.41L7.1 5.69C8.46 4.64 10.15 4 12 4C16.07 4 19.44 7.06 19.93 11ZM4 12C4 10.15 4.63 8.46 5.69 7.1L11 12.41V19.93C7.06 19.44 4 16.07 4 12ZM13 19.93V13H19.93C19.48 16.61 16.61 19.48 13 19.93Z" fill={ fill || 'currentColor' } />
    </svg>
);
